import { useEffect, useState } from 'react';
import { DatePicker, Input, Message, Space, Typography } from '@arco-design/web-react';
import dayjs from 'dayjs';
import FormModal from '../../../components/FormModal';
import { createWorkbenchCallback } from '../../../api/outbound';
import { maskPhone } from '../../../utils/format';

/** 话后「预约回呼」：号码预填，到点由调度器拨进本人技能组队列 */
export default function CallbackModal(props: { visible: boolean; number: string; onClose: () => void }) {
  const { visible, number, onClose } = props;
  const [when, setWhen] = useState('');
  const [remark, setRemark] = useState('');
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (visible) {
      setWhen(dayjs().add(1, 'hour').format('YYYY-MM-DD HH:mm'));
      setRemark('');
    }
  }, [visible]);
  const submit = async () => {
    if (!number) {
      Message.warning('无可预约号码');
      return;
    }
    if (!when) {
      Message.warning('请选择预约时间');
      return;
    }
    const at = dayjs(when);
    if (!at.isValid() || at.isBefore(dayjs().subtract(1, 'minute'))) {
      Message.warning('预约时间须晚于当前');
      return;
    }
    setSaving(true);
    try {
      await createWorkbenchCallback({
        phone: number,
        scheduledAt: at.toISOString(),
        remark: remark.trim() || undefined,
      });
      Message.success(`已预约回呼 ${maskPhone(number)}`);
      onClose();
    } catch {
      /* 拦截器已提示 */
    } finally {
      setSaving(false);
    }
  };
  /* 预约回呼（操作录入表单，表单档 560） */
  return (
    <FormModal
      title="预约回呼"
      visible={visible}
      onCancel={onClose}
      onOk={submit}
      okText="确认预约"
      cancelText="取消"
      confirmLoading={saving}
    >
      <Space direction="vertical" size={8} style={{ width: '100%' }}>
        <Typography.Text type="secondary">号码</Typography.Text>
        <Input value={maskPhone(number)} readOnly />
        <Typography.Text type="secondary">预约时间</Typography.Text>
        <DatePicker
          showTime
          format="YYYY-MM-DD HH:mm"
          style={{ width: '100%' }}
          value={when || undefined}
          onChange={(v) => setWhen(v || '')}
        />
        <Typography.Text type="secondary">备注（可选）</Typography.Text>
        <Input value={remark} onChange={setRemark} placeholder="如：客户要求下午回访" maxLength={200} />
      </Space>
    </FormModal>
  );
}
